/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Preference_LikeInputs */

const en_us2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I like this one`)
};

const pt_br2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gosto deste`)
};

const es_419_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me gusta este`)
};

const pt_pt2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gosto deste`)
};

const fr_fr2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'aime bien`)
};

const de_de2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag ich`)
};

const it_it2_exercise_personal_preference_like = /** @type {(inputs: Exercise_Personal_Preference_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi piace`)
};

/**
* | output |
* | --- |
* | "I like this one" |
*
* @param {Exercise_Personal_Preference_LikeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_preference_like = /** @type {((inputs?: Exercise_Personal_Preference_LikeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Preference_LikeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_preference_like(inputs)
	if (locale === "es-419") return es_419_exercise_personal_preference_like(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_preference_like(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_preference_like(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_preference_like(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_preference_like(inputs)
	return en_us2_exercise_personal_preference_like(inputs)
});
export { exercise_personal_preference_like as "exercise-personal.preference_like" }